import { StateUtils } from '@spartacus/core';
import { EntriesState } from '../../../../../core/features/store/base-feature-state';
import { TinyCart } from '../../../../../core/model';
import {
  AddCartEntrySuccess,
  CartEntryActionTypes,
  QuickAddCartEntrySuccess,
  RemoveCartEntrySuccess,
} from '../actions/cart-entry.action';
import { CartActions } from '../actions/index';
import { LoadTinyCartsSuccess, LoadTinyCartSuccess, RemoveTinyCart, TinyCartActionTypes } from '../actions/tiny-cart.action';

export const initialState: EntriesState<TinyCart> = {};

export function reducer(
  state = initialState,
  action: CartActions.TinyCartActions | CartActions.CartEntryActions | StateUtils.LoaderAction
): EntriesState<TinyCart> {
  switch (action.type) {
    case TinyCartActionTypes.LoadTinyCartsSuccess: {
      const successAction = <LoadTinyCartsSuccess>action;
      return successAction.payload.reduce((entities: { [type: string]: TinyCart }, tinyCart: TinyCart) => {
        if (Boolean(entities[tinyCart.cartType])) {
          console.error('ESVCX-2429: Unexpected multiple tiny carts of type ' + tinyCart.cartType);
          return entities;
        }
        return {
          ...entities,
          [tinyCart.cartType]: tinyCart,
        };
      }, initialState);
    }
    case TinyCartActionTypes.LoadTinyCartSuccess: {
      const successAction = <LoadTinyCartSuccess>action;
      return {
        ...state,
        [successAction.payload.cartType]: successAction.payload,
      };
    }
    case TinyCartActionTypes.RemoveTinyCart: {
      const removeAction = <RemoveTinyCart>action;
      if (!removeAction.payload.cartId) {
        // If we don't specify an id, remove any tiny cart of cart type
        return {
          ...state,
          [removeAction.payload.cartType]: undefined,
        };
      } else {
        return state;
      }
    }
    case CartEntryActionTypes.AddCartEntrySuccess:
    case CartEntryActionTypes.AddA4SampleCartEntrySuccess:
    case CartEntryActionTypes.QuickAddCartEntrySuccess: {
      const addAction = <AddCartEntrySuccess | QuickAddCartEntrySuccess>action;
      const tinyCart = (state && state[addAction.payload.cartType]) || {
        code: addAction.payload.cartId,
        cartType: addAction.payload.cartType,
        numberOfEntries: 0,
      };
      return {
        ...state,
        [addAction.payload.cartType]: {
          ...tinyCart,
          numberOfEntries: tinyCart.numberOfEntries + 1,
        },
      };
    }
    case CartEntryActionTypes.RemoveCartEntrySuccess: {
      const removeAction = <RemoveCartEntrySuccess>action;
      const tinyCart = state[removeAction.payload.cartType];
      return {
        ...state,
        [removeAction.payload.cartType]: {
          ...tinyCart,
          numberOfEntries: tinyCart.numberOfEntries - 1,
        },
      };
    }
    default: {
      return state;
    }
  }
}
